import styled from 'styled-components/macro';
import CircularProgress from '@mui/material/CircularProgress';

const ButtonSpinner = styled(CircularProgress).attrs({
  size: 20,
})`
  color: #fff;
`;

export default ButtonSpinner;
